

import React from "react";
import "./Info.css";
const Info = () => {
  return (
    <div className="info">
      <div className="heading-container">
        <div className="heading-line"></div>
        <div className="heading">Har DP Tiranga 13 August, 2023 </div>
      </div>
      <div className="text1">
      We will request to all the Tian to change their social media DPs.
      On this day, we will embark on a heartfelt initiative, urging all members of the institution, both students and staff, to show their patriotism by changing their social media display pictures to the glorious Indian tricolor - the Tiranga. This simple yet impactful gesture will demonstrate our collective pride in our nation and set the tone for the upcoming Independence Day celebrations.
      </div>
      <div className="text2">
        They are also encouraged to take a selfie and upload the same to the
        given link : <a href="/login"> <b>Upload Photos</b></a>   
      </div>
      <div className="extra">
        <div className="date">
          <span style={{ fontWeight: "bold" }}>Date</span>: 13 August, 2023
        </div>
        {/* <div className="time">Time: 4:00 PM</div>
        <div className="location">Venue: Adminsitrative Building</div> */}
      </div>
    </div>
  );
};

export default Info;

